import { useLocale } from "next-intl";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export function useLocalizedQuery<TQueryFnData, TData = TQueryFnData>({
  queryKey,
  queryFn,
  options,
}: {
  queryKey: any[];
  queryFn: (lang: string) => Promise<TQueryFnData>;
  options?: Omit<UseQueryOptions<TQueryFnData, unknown, TData>, "queryKey" | "queryFn">;
}) {
  const locale = useLocale();

  return useQuery({
    queryKey: [...queryKey, locale],
    queryFn: () => queryFn(locale),
    ...options,
  });
}
